import { render } from "./bill-center.vue?vue&type=template&id=08c7fa6c&scoped=true&ts=true"
import script from "./bill-center.vue?vue&type=script&lang=ts"
export * from "./bill-center.vue?vue&type=script&lang=ts"

import "./bill-center.vue?vue&type=style&index=0&id=08c7fa6c&scoped=true&lang=stylus"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c7fa6c"]])

export default __exports__